module.exports = __webpack_public_path__ + "static/media/privacy.4aa25eb5.md";